import React, { useEffect, useRef, useState, } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Reset_Pass.css';
import EditPopup from './EditPopup';
import { BASE_URL } from "../../constants";
import { Flex } from '@chakra-ui/react';

function Reset_Pass() {

    const [userId, setUserId] = useState(1);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [hideStatusControls, setHideStatusControls] = useState(false);
    const [resetPassword, setResetPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return (
        password.length >= minLength &&
        hasUpperCase &&
        hasLowerCase &&
        hasNumber &&
        hasSpecialChar
    );
    };
 
    const fetchUsers = () => {
        fetch(`${BASE_URL}/api/all_users`)
          .then(response => response.json())
          .then(data => setUsers(data))
          .catch(error => console.error('Error fetching users:', error));
      };
      
      useEffect(() => {
        fetchUsers();
      }, []);


    // When user row clicked, copy user data to editable state
    const onSelectUser = (user) => {
    setSelectedUser({ ...user });
    setHideStatusControls(false); // Show radio controls again when a row is clicked
    setResetPassword('');
    setConfirmPassword('');
    };

    const handleRadioChange = (field, value) => {
    setSelectedUser(prev => ({
        ...prev,
        [field]: value,
    }));
    };
    
    

    const handleResetPassword = (user) => {
    setSelectedUser({ ...user });
    setHideStatusControls(true); // hide radio controls
    setResetPassword('');
    setConfirmPassword('');
    };

     
   const handleSave = () => {
  if (!selectedUser) return;

  if (hideStatusControls) {
    // Reset password mode
    if (!resetPassword || !confirmPassword) {
      alert('Please fill in both password fields.');
      return;
    }

    if (resetPassword !== confirmPassword) {
      alert('Passwords do not match.');
      return;
    }

    if (!validatePassword(resetPassword)) {
      alert('Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.');
      return;
    }

    // Call password reset API
    axios.post(`${BASE_URL}/api/reset_password`, {
      userId: selectedUser.user_id,
      new_password: resetPassword,
    })
    .then((response) => {
      alert('Password reset successful.');
      setHideStatusControls(false);
      setSelectedUser(null);
      setResetPassword('');
      setConfirmPassword('');
      fetchUsers();
    })
    .catch((error) => {
      if (error.response) {
        alert(error.response.data.message || 'Error resetting password.');
      } else {
        alert('Password reset failed.');
      }
      console.error('Password reset failed:', error);
    });

  } else {

    axios.put(`${BASE_URL}/api/update_user_status`, {
        userId: selectedUser.user_id,
        is_logged_in: selectedUser.is_logged_in,
        lock_user: selectedUser.lock_user,
      })
      .then(() => {
        alert('User status updated successfully.');
        setSelectedUser(null);
        fetchUsers();
      })
      .catch((error) => {
        console.error('User status update failed:', error);
        alert('Failed to update user status.');
      });
    }
};




    return (
        <div className="px-5 py-1" style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <div className="card flex-grow-1 d-flex flex-column">

                <div className="card-header-css">
                    <h5 className="text-center">Reset User/Password</h5>
                </div>
                <div className="card-body" style={{ flex: '0 0 auto' }}>
                    <div className="row">
                        <div className="col-md-6 mb-3 d-flex">
                        <label htmlFor="loginId" className="form-label label-width">LoginId:</label>
                        <input
                            id="loginId"
                            type="text"
                            className="form-control size_input_cashbank"
                            value={selectedUser?.login_id || ''}
                            readOnly
                        />
                        </div>

                        <div className="col-md-6 mb-3 d-flex">
                        <label htmlFor="username" className="form-label label-width">Username:</label>
                        <input
                            id="username"
                            type="text"
                            className="form-control size_input_cashbank"
                            value={selectedUser?.user_name || ''}
                            readOnly
                        />
                        </div>
                    </div>

                    {selectedUser && (
                    <>
                        {!hideStatusControls ? (
                        <div className="row">
                            {/* Is Logged In */}
                            <div className="col-md-6 mb-3 d-flex align-items-center">
                            <label className="form-label label-width">Is Logged In:</label>
                            <div className="form-check form-check-inline">
                                <input
                                className="form-check-input"
                                type="radio"
                                name="isLoggedIn"
                                checked={(selectedUser?.is_logged_in || 'N') === 'Y'}
                                onChange={() => handleRadioChange('is_logged_in', 'Y')}
                                />
                                <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                className="form-check-input"
                                type="radio"
                                name="isLoggedIn"
                                checked={(selectedUser?.is_logged_in || 'N') === 'N'}
                                onChange={() => handleRadioChange('is_logged_in', 'N')}
                                />
                                <label className="form-check-label">No</label>
                            </div>
                            </div>

                            {/* Lock User */}
                            <div className="col-md-6 mb-3 d-flex align-items-center">
                            <label className="form-label label-width">Lock User:</label>
                            <div className="form-check form-check-inline">
                                <input
                                className="form-check-input"
                                type="radio"
                                name="lockUser"
                                checked={(selectedUser?.lock_user || 'N') === 'Y'}
                                onChange={() => handleRadioChange('lock_user', 'Y')}
                                />
                                <label className="form-check-label">Yes</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                className="form-check-input"
                                type="radio"
                                name="lockUser"
                                checked={(selectedUser?.lock_user || 'N') === 'N'}
                                onChange={() => handleRadioChange('lock_user', 'N')}
                                />
                                <label className="form-check-label">No</label>
                            </div>
                            </div>
                        </div>
                        ) : (
                        <div className="row">
                            <div className="col-md-6 mb-3 d-flex">
                            <label htmlFor="resetPassword" className="form-label label-width">Reset Password:</label>
                            <input
                                type="password"
                                id="resetPassword"
                                className="form-control size_input_cashbank"
                                value={resetPassword}
                                onChange={(e) => setResetPassword(e.target.value)}
                            />
                            </div>

                            <div className="col-md-6 mb-3 d-flex">
                            <label htmlFor="confirmPassword" className="form-label label-width">Confirm Password:</label>
                            <input
                                type="password"
                                id="confirmPassword"
                                className="form-control size_input_cashbank"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            </div>
                        </div>
                        )}
                    </>
                    )}

                    <div className="mt-4">
                        <div className="d-flex" style={{ float: 'right' }}>
                        <button className="btn btn-success me-2" style={{ width: '150px' }} onClick={handleSave}>Save</button>
                        </div>
                    </div>
                    </div>


                {/* <div className='table-container overflow-auto' style={{ flex: '1 1 auto' }}> */}
                    <table className="table mt-1 table-wrapper" style={{ height: '100px' }}>
                        <thead className='table-primary' style={{position: 'sticky', top: 0, index: 1}}>
                            <tr>
                                <th style={{width:'150px'}}>Login Id</th>
                                <th style={{width:'200px'}}>User name</th>
                                <th style={{width:'200px'}}>Last Login</th>
                                <th style={{width:'80px'}}>Is Logged In</th>
                                <th style={{width:'80px'}}> Logged Out Datetime</th>
                                <th style={{width:'80px'}}> Status</th>
                                <th style={{ width: '80px' }}>Lock User</th>
                                <th style={{ width: '100px' }}>Reset Password</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.length > 0 ? (
                                users.map(user => (
                                <tr
                                    key={user.user_id}
                                    onClick={() => onSelectUser(user)}
                                    className={selectedUser?.user_id === user.user_id ? 'table-active' : ''}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>{user.login_id}</td>
                                    <td>{user.user_name}</td>
                                    <td>{user.last_login_date}</td>
                                    <td>{user.is_logged_in}</td>
                                    <td>{user.logged_out_datetime}</td>
                                    <td>
                                        {user.user_status === 'H' ? 'Hold' :
                                        user.user_status === 'A' ? 'Active' :
                                        user.user_status === 'I' ? 'Inactive' :
                                        user.user_status === 'R' ? 'Resigned' :
                                        user.user_status}
                                    </td>
                                    <td>{user.lock_user}</td>
                                    <td>
                                    <button
                                        className='btn'
                                        style={{
                                            width: '100px',
                                            height: '20px',
                                            background: 'orange',
                                            color: 'black',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center', // vertical centering
                                            padding: 0, // remove default padding if needed
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleResetPassword(user);
                                        }}
                                        >
                                        Reset
                                        </button>
                                    </td>
                                </tr>
                                ))
                            ) : (
                                <tr>
                                <td colSpan="6" className="text-center">No users found</td>
                                </tr>
                            )}
                                                                                
                        </tbody>
                    </table>
                </div>
            {/* </div> */}
        </div>
    );
}

export default Reset_Pass;
